<script>
export default {
  name: 'cta-button',
  props: [
    'href',
    'target',
    'title',
    'text',
    'classNames',
    'loading',
    'variant',
    'disabled',
    'iconFlipped',
    'showIcon'
  ]
}

</script>
<template>
  <component
    :is="href !== null && href !== undefined && href !== '' ? 'a' : 'button'"
    class="inline-flex relative cursor-pointer items-center text-xs font-bold gap-2 px-5 leading-none duration-200 ease-in-out hover:rounded-[40px] focus:rounded-[40px]"
    :class="{
      'font-display py-4 bg-red-400 text-white': variant === undefined,
      'font-display py-4 bg-blue-400 text-white': variant === 'blue',
      'font-display py-4 bg-beige-400 text-black': variant === 'grey',
      'font-display py-4 opacity-25 cursor-not-allowed': disabled,
      'font-medium font-ab-display py-3.5 bg-black text-white': variant === 'ab',
      'font-medium py-3.5 bg-black text-white': variant === 'bio',
      [classNames]: classNames !== undefined
    }"
    :href="href ?? undefined"
    :target="href ? target : null"
    :title="title ?? text"
    :disabled="!href && disabled"
    @click="
      () => {
        if (!disabled) {
          $emit('click')
        }
      }
    "
  >
    <div id="loading-bar-spinner" v-if="loading">
      <div class="w-4 h-4 border-2 border-transparent rounded-full animate-spin border-t-white border-l-white"></div>
    </div>
    <span>{{ text }}</span>
    <svg
      v-if="!showIcon"
      class="style-icon"
      :class="{ '-order-1 rotate-180': iconFlipped }"
    >
      <use
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xlink:href="/dist/icons/sprite.svg#icon-arrow"
      ></use>
    </svg>
  </component>
</template>